module.exports = __webpack_public_path__ + "img/btn-gis.5165cd54.png";